import { NavigationItem, NestedEntryNavigationItem } from 'interfaces/navigation-data';

// Nav titles are Contentful literals, not i18n keys: match on this key's resolved value.
export const BREEDS_TITLE_ID = 'navigation:dogs:breeds:title';

const isNestedItem = (item: NavigationItem): item is NestedEntryNavigationItem =>
  item.itemType === 'nested-entry' || item.itemType === 'nested-card';

const byLocalizedTitle =
  (locale: string) =>
  (a: NavigationItem, b: NavigationItem): number =>
    (a.title ?? '').localeCompare(b.title ?? '', locale, { sensitivity: 'base' });

export const withSortedBreeds = (
  items: NavigationItem[],
  breedsTitle: string,
  locale: string
): NavigationItem[] =>
  items.map((item) => {
    if (!isNestedItem(item)) return item;

    if (item.title === breedsTitle) {
      return { ...item, items: item.items.toSorted(byLocalizedTitle(locale)) };
    }

    return { ...item, items: withSortedBreeds(item.items, breedsTitle, locale) };
  });
